module.exports = __webpack_public_path__ + "static/media/icono_trigo.7d2dd57c.png";